var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "userId",
                    label: "用户id",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入用户id" },
                    model: {
                      value: _vm.model.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "userId", $$v)
                      },
                      expression: "model.userId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "realName",
                    label: "真实姓名",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入真实姓名" },
                    model: {
                      value: _vm.model.realName,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "realName", $$v)
                      },
                      expression: "model.realName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "documentType",
                    label:
                      "证件类型(1港澳居民来往内地通行证 2台湾居民来往内地通行证 3外国人永久居留证 4中国大陆身份证)",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.documentType,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "documentType", $$v)
                      },
                      expression: "model.documentType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "documentNumber",
                    label: "证件号码",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入证件号码" },
                    model: {
                      value: _vm.model.documentNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "documentNumber", $$v)
                      },
                      expression: "model.documentNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "documentPhotoFront",
                    label: "证件照（人像面）",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入证件照（人像面）" },
                    model: {
                      value: _vm.model.documentPhotoFront,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "documentPhotoFront", $$v)
                      },
                      expression: "model.documentPhotoFront",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "documentPhotoBack",
                    label: "证件照（国徽面）",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入证件照（国徽面）" },
                    model: {
                      value: _vm.model.documentPhotoBack,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "documentPhotoBack", $$v)
                      },
                      expression: "model.documentPhotoBack",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "documentPhotoHand",
                    label: "手持证件照",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入手持证件照" },
                    model: {
                      value: _vm.model.documentPhotoHand,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "documentPhotoHand", $$v)
                      },
                      expression: "model.documentPhotoHand",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "status",
                    label: "审核状态 1审核中 2通过 3未通过",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "status", $$v)
                      },
                      expression: "model.status",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-bootom-button" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v("确定")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }